<template>

  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >

        <v-alert
            v-if="haserror"
            color="pink"
            dark
            border="top"
            icon="mdi-alert-circle"
            transition="scale-transition"
        >
          {{ $t("No reconocemos este usuario y/o contraseña") }}
        </v-alert>

        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-card class="elevation-12">
            <v-toolbar
                color="primary"
                dark
                flat
            >
              <v-toolbar-title>{{ $t("Area de registro")}}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <ValidationProvider v-slot="{ errors }" rules="required|email">
                  <v-text-field
                      label="Email"
                      name="login"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="username"
                      :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                      id="password"
                      :label="$t('Contraseña')"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="password"
                      :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-form>
              <p class="text-right">
                <router-link to="/lost-password">{{$t('He olvidado mi contraseña')}}</router-link>
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="submit" color="primary">{{$t('Enviar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

    import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

    setInteractionMode('eager')

    export default {
        name: "login",

        props: {
            source: String,
        },
        components: {
            ValidationProvider, ValidationObserver
        },
        data() {
            return {
                haserror: false,
                username: "",
                password: ""

            }
        },
        methods: {
            submit() {
                this.$refs.observer.validate().then(success => {
                    if (success) {
                        let u = this.username
                        let p = this.password
                        const payload = {
                            "username": u,
                            "password": p
                        }
                        this.$store.dispatch("obtainToken", payload)
                            .then(async () => {
                                if (this.$store.state.jwt) {
                                    await this.$store.dispatch('getUser')
                                    this.$i18n.locale = this.$store.state.lang
                                    if(this.$store.state.usergroup == "user"){
                                      this.$router.replace('/eventos')
                                    }
                                    else{
                                      this.$router.replace('/eventos/admin')
                                    }

                                } else {
                                    this.haserror = true
                                }
                            })
                            .catch(() => {
                                this.haserror = true
                                alert("Error")
                            })
                    }
                })
            }
        }
    }
</script>
